import { Camera } from 'lucide-react';
import { Outlet } from 'react-router';

export function PublicGalleryLayout() {
  return <div className="bv-public-gallery-layout">
    <header className="bv-public-gallery-header" aria-label="Boothiva">
      <Camera aria-hidden="true" size={30} />
      <span className="bv-public-gallery-brand">Boothiva</span>
    </header>
    <main className="bv-public-gallery-main"><Outlet /></main>
  </div>;
}
